import React, { useState } from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const testimonials = [
        {
            id: 1,
            name: "أحمد محمد",
            rating: 5,
            text: "تجربة رائعة! الخدمة ممتازة والمكان نظيف جداً. المساج كان مريح للغاية وساعدني على الاسترخاء التام. أنصح الجميع بزيارة المركز.",
            service: "مساج استرخائي"
        },
        {
            id: 2,
            name: "خالد العتيبي",
            rating: 5,
            text: "الحمام المغربي في هذا المركز أفضل ما جربته. الفريق محترف جداً ويهتم بأدق التفاصيل. المكان فخم والأسعار ممتازة.",
            service: "حمام مغربي"
        },
        {
            id: 3,
            name: "عبدالله السعيد",
            rating: 5,
            text: "خدمة من الدرجة الأولى! البديكير كان احترافي جداً والنتيجة رائعة. المركز نظيف ومريح والموظفين ودودين للغاية.",
            service: "بديكير"
        },
        {
            id: 4,
            name: "محمد الغامدي",
            rating: 5,
            text: "أفضل مركز عناية في جدة! الأسعار معقولة والجودة عالية جداً. أصبحت زبون دائم وأنصح كل من يبحث عن الاسترخاء والعناية.",
            service: "خدمات شاملة"
        }
    ];

    const nextTestimonial = () => {
        setCurrentIndex((prevIndex) => 
            prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevTestimonial = () => {
        setCurrentIndex((prevIndex) => 
            prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
        );
    };

    const goToTestimonial = (index) => {
        setCurrentIndex(index);
    };

    return (
        <div className="testimonials-section">
            <h2 className="testimonials-title">آراء عملائنا</h2>
            <p className="testimonials-subtitle">ماذا يقول عملاؤنا عن خدماتنا</p>
            
            <div className="testimonials-container">
                <button className="nav-button prev" onClick={prevTestimonial} aria-label="Previous testimonial">
                    ❮
                </button>

                <div className="testimonial-card">
                    <FaQuoteLeft className="quote-icon" />
                    <div className="rating">
                        {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                            <FaStar key={i} className="star" />
                        ))}
                    </div>
                    <p className="testimonial-text">{testimonials[currentIndex].text}</p>
                    <div className="testimonial-author">
                        <h4>{testimonials[currentIndex].name}</h4>
                        <p className="service-type">{testimonials[currentIndex].service}</p>
                    </div>
                </div>

                <button className="nav-button next" onClick={nextTestimonial} aria-label="Next testimonial">
                    ❯
                </button>
            </div>

            <div className="dots-container">
                {testimonials.map((_, index) => (
                    <button
                        key={index}
                        className={`dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => goToTestimonial(index)}
                        aria-label={`Go to testimonial ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default Testimonials;
